const certificatesLoadMore = (container, loadMore, parent, cb) => {

    $(parent).each((i, el) => {
        let btn = $(el).find(loadMore),
        currentContainer =  $(el).find(container);

        $(btn).click(function(ev) {
            let target = $(ev.currentTarget),
                currentPage= + $(btn).attr('data-page'),
                max = +target.attr('data-max'),
                perPage = +target.data('per-page'),
                termSlug = $(el).data('cat');

            target.attr('disabled', 'true');

            if(currentPage < max) {
                let next = currentPage + 1;
                let data = {
                    action: 'posts_load_more',
                    termSlug: termSlug,
                    paged : next,
                    perPage: perPage,
                    postType:  'certificates',
                    taxonomy : 'certificates-category',
                };

                ajaxRequest(data, (response)=> {
                    $(currentContainer).append(response);
                    target.attr('data-page', next);
                    target.removeAttr('disabled');

                    if(next === max ) {
                        target.hide();
                    }

                    cb();
                })
            }
        });
    })


    function ajaxRequest(data, cb) {
        $.ajax({
            type: 'POST',
            url: ajax_url[0],
            dataType: "html",
            data: data,
            success: function (response) {
                cb(response);
            },
            error: function (error) {
                console.log('error', error);
            }
        });
    }
};

export default certificatesLoadMore;